export default __webpack_public_path__ + "static/media/like.03c0bcf1.png";